import { RefObject, useRef, useEffect } from "react";

const usePrevious: <T>(value: T) => T = <T>(value: T): T => {
  const ref: RefObject<T> = useRef<T>(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
